import InViewport from 'in-viewport';

// Offset from page height until element is declared 'visible'
const defaultOffset = -100;

export default class Visible {
  constructor(element, offset) {
    this.offset = offset || defaultOffset;
    this.element = element;
    this.listen();
  }

  visibleHandler() {
    this.element.classList.add('visible');
  }

  listen() {
    InViewport(this.element, { offset: this.offset }, this.visibleHandler.bind(this));
  }
}
